
import Image, { type ImageProps } from '2-core-elements/Image/Image';
import { type FC } from 'react';
import Button from '2-core-elements/Buttons/Button';
import DuotoneIcon from '2-core-elements/Icon/DuotoneIcon';


interface MapCardInfoItemProps {
    label: string;
    value: string;
}

const CardInfoItem: FC<MapCardInfoItemProps> = ({
    label,
    value,
}) => {
    return (
        <div className="card-info-item">
            <div className="card-info-item-label">{label}</div>
            <div className="card-info-item-value">{value}</div>
        </div>
    );
};

export type MapCardProps = {
    img?: Pick<ImageProps, 'imgSrc' | 'imgAlt' | 'imgHeight' | 'imgWidth' | 'imgSrcSet'>;
    link?: { href: string; label?: string; target?: '_self' | '_blank' };
    title: string;
    children?: React.ReactNode;
    infoItems?: MapCardInfoItemProps[];
    onCloseButtonClick?: () => void;
    icon?: string;
};

const MapCard = ({
    img,
    link = { href: '', label: '', target: '_self' },
    title,
    children,
    infoItems,
    onCloseButtonClick,
    icon,
}: MapCardProps): JSX.Element => {
    return (
        <div className={`map-card`} aria-label={title}>
            <div className="card-header">
                {icon && <DuotoneIcon icon={icon} className="card-header-top-icon" />}
                <h2 className="card-title">
                    {title}
                </h2>
                <Button onClick={onCloseButtonClick} className="card-close-btn" skin="3" onlyIcon={true} prefixIcon="close" size={null} />
            </div>
            {img && (
                <div className="card-img">
                    <Image aspectRatio="3/2" imgSrc={img.imgSrc} imgAlt={img.imgAlt} imgSrcSet={img.imgSrcSet} />
                </div>
            )}

            <div className="card-content">
                {!!infoItems && !!infoItems.length && (
                    <div className="card-info-items">
                        {infoItems.map(({ label, value }) => {
                            return (
                                <CardInfoItem key={`${label}`} label={label} value={value} />
                            );
                        })}
                    </div>
                )}
                {children && (
                    <div className="card-description">
                        {children}
                    </div>
                )}
                {link && (
                    <div className="card-cta-container">
                        <Button className="card-cta-btn" href={link.href} suffixIcon="arrow-right">
                            {link.label}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MapCard;
